import { PageMeta } from 'constants/pages';
import { ArticleSections } from 'types/articles';
import { waveSensePartnership, waveSensePartnershipMeta } from './wave-sense';
import { amdSiloPartnership, amdSiloPartnershipMeta } from './amd-silo';

interface IPartnershipData {
  pageMeta: PageMeta;
  articleData: ArticleSections[];
}

export const PARTNERSHIPS: IPartnershipData[] = [
  {
    pageMeta: waveSensePartnershipMeta,
    articleData: waveSensePartnership,
  },
  {
    pageMeta: amdSiloPartnershipMeta,
    articleData: amdSiloPartnership,
  },
];
